import { useBackend } from "../../services";
import { ICollection } from "../collections";

export const useImportFromSpreadsheet = () => {
  const { upload } = useBackend();
  const importFromSpreadsheet = async (file: File, collections: ICollection[], userId: string) => {
    const collectionsJson = JSON.stringify(collections);
    return upload("xlsx", `${userId}.xlsx`, file, "collections", collectionsJson);
  };
  return { importFromSpreadsheet };
};
